import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import styles from './styles.module.scss';

class ExploreView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            programs: [],
            loading: true,
            error: null
        };
    }

    componentDidMount() {
        this.fetchPrograms();
    }

    fetchPrograms = async () => {
        this.setState({ loading: true, error: null });

        try {
            const response = await fetch('/api/explore');

            if (response.ok) {
                const programs = await response.json();
                this.setState({ programs, loading: false, error: null });
            } else {
                this.setState({ error: 'Failed to load programs', loading: false });
            }
        } catch (error) {
            this.setState({ error: 'Failed to load programs', loading: false });
        }
    }

    formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    }

    render() {
        const { programs, loading, error } = this.state;

        return (
            <div className={styles.container}>
                <Helmet>
                    <title>Explore Training Programs - RepOne</title>
                    <meta name="description" content="Discover and explore public training programs created by coaches and athletes on RepOne. Find your next workout program." />
                    <meta name="keywords" content="training programs, workout programs, fitness, exercise, RepOne, explore, discover" />
                    <meta name="robots" content="index, follow" />
                    <link rel="canonical" href={`${window.location.origin}/explore`} />
                </Helmet>

                <header className={styles.header}>
                    <h1>Explore Training Programs</h1>
                    <p>Discover public training programs shared by coaches and athletes</p>
                </header>

                <main className={styles.main}>
                    {loading && (
                        <div className={styles.loading}>
                            <div className={styles.spinner}></div>
                            <p>Loading programs...</p>
                        </div>
                    )}

                    {error && (
                        <div className={styles.error}>
                            <h2>Unable to load programs</h2>
                            <p>{error}</p>
                            <button onClick={this.fetchPrograms} className={styles.retryButton}>
                                Try Again
                            </button>
                        </div>
                    )}

                    {!loading && !error && programs.length === 0 && (
                        <div className={styles.empty}>
                            <h2>No public programs available</h2>
                            <p>Check back later for new training programs!</p>
                        </div>
                    )}

                    {!loading && !error && programs.length > 0 && (
                        <div className={styles.programGrid}>
                            {programs.map(program => (
                                <Link
                                    key={program.id}
                                    to={`/shared/${program.id}`}
                                    className={styles.programCard}
                                >
                                    <div className={styles.programContent}>
                                        <h3 className={styles.programName}>{program.name}</h3>

                                        {program.notes && (
                                            <p className={styles.programDescription}>
                                                {program.notes.length > 120
                                                    ? `${program.notes.substring(0, 120)}...`
                                                    : program.notes
                                                }
                                            </p>
                                        )}

                                        {program.authorInfo && (
                                            <div className={styles.authorInfo}>
                                                {program.authorInfo.avatar ? (
                                                    <img
                                                        src={program.authorInfo.avatar}
                                                        alt={program.authorInfo.name}
                                                        className={styles.authorAvatar}
                                                    />
                                                ) : (
                                                    <div className={styles.authorAvatarPlaceholder}>
                                                        {program.authorInfo.name ? program.authorInfo.name.charAt(0).toUpperCase() : '?'}
                                                    </div>
                                                )}
                                                <span className={styles.authorName}>
                                                    by {program.authorInfo.name}
                                                </span>
                                            </div>
                                        )}

                                        <div className={styles.programMeta}>
                                            <span className={styles.createdDate}>
                                                Created {this.formatDate(program.created_on)}
                                            </span>
                                        </div>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    )}
                </main>
            </div>
        );
    }
}

export default ExploreView;